export default __webpack_public_path__ + "app/images/theme-images/dark/context-font-size-btn-disabled/icon-20-text@2x.webp";